import { render, staticRenderFns } from "./declaracaoArqFederalView.vue?vue&type=template&id=842a2c3c&scoped=true&"
import script from "./declaracaoArqFederalView.vue?vue&type=script&lang=js&"
export * from "./declaracaoArqFederalView.vue?vue&type=script&lang=js&"
import style0 from "./declaracaoArqFederalView.vue?vue&type=style&index=0&id=842a2c3c&lang=scss&scoped=true&"
import style1 from "./declaracaoArqFederalView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842a2c3c",
  null
  
)

export default component.exports